export default [
    {
        id: 1,
        name_ca: 'Desconeguda',
        name_es: 'Desconocida',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'Cap',
        name_es: 'Ninguno',
        name_en: 'None'
    }, {
        id: 3,
        name_ca: 'Pintat',
        name_es: 'Pintado',
        name_en: 'Painted'
    }, {
        id: 4,
        name_ca: 'Enguixat i pintat',
        name_es: 'Enyesado y pintado',
        name_en: 'Plastered and painted'
    }, {
        id: 5,
        name_ca: 'Rajola ceràmica esmaltada',
        name_es: 'Baldosa cerámica esmaltada',
        name_en: 'Glazed ceramic tile'
    }, {
        id: 6,
        name_ca: 'Rajola ceràmica natural',
        name_es: 'Baldosa cerámica natural',
        name_en: 'Ceramic tile'
    }, {
        id: 7,
        name_ca: 'Rajola de gres porcellànic',
        name_es: 'Baldosa de gres porcelánico',
        name_en: 'Porcelain stoneware tile'
    }, {
        id: 8,
        name_ca: 'Rajola de gres extruït sense esmaltar',
        name_es: 'Baldosa de gres extruido sin esmaltar',
        name_en: 'Unglazed extruded stoneware tile'
    }, {
        id: 9,
        name_ca: 'Rajola de gres extruït esmaltada',
        name_es: 'Baldosa de gres extruido esmaltada',
        name_en: 'Glazed extruded stoneware tile'
    }, {
        id: 10,
        name_ca: 'Rajola de gres premsat esmaltat',
        name_es: 'Baldosa de gres prensado esmaltado',
        name_en: 'Glazed pressed stoneware tile'
    }, {
        id: 11,
        name_ca: 'Rajola de gres porcellànic',
        name_es: 'Baldosa de gres porcelánico',
        name_en: 'Porcelain stoneware tile'
    }, {
        id: 12,
        name_ca: 'Arrebossat',
        name_es: 'Rebozado',
        name_en: 'Coated'
    }, {
        id: 13,
        name_ca: 'Estucat',
        name_es: 'Estucado',
        name_en: 'Coated'
    }, {
        id: 14,
        name_ca: 'Aplacat de fusta natural',
        name_es: 'Aplacado de madera natural',
        name_en: 'Natural wood paneling'
    }, {
        id: 15,
        name_ca: 'Aplacat amb plaques sintètiques',
        name_es: 'Aplacado con placas sintéticas',
        name_en: 'Synthetic paneling'
    }, {
        id: 16,
        name_ca: 'Obra vista',
        name_es: 'Obra vista',
        name_en: 'Brickwork'
    }, {
        id: 17,
        name_ca: 'Gresite',
        name_es: 'Gresite',
        name_en: 'Gresite'
    }
]





// WEBPACK FOOTER //
// ./src/options/walls.js